import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation} from 'react-router-dom'; // Assuming you're using react-router

function sendPageView(pathName) {
  ReactGA.send({ hitType: "pageview", page: pathName });
}

function useTrackPageView(isTrackingAllowed) {
  let location = useLocation();

  useEffect(() => {
    if (!isTrackingAllowed) return

    sendPageView(location.pathname);
  }, [location.pathname, isTrackingAllowed]);
}

export default useTrackPageView;
